import { motion } from "framer-motion";
import { Tag, SearchCheck, Truck, Droplets, Handshake } from "lucide-react";

const SERVICES = [
  { icon: Tag, title: "Private Label Manufacturing", desc: "Your brand, our production floor — labels, packaging and QC handled end-to-end." },
  { icon: SearchCheck, title: "Fabric Sourcing & Inspection", desc: "Mill-direct sourcing with lot-by-lot inspection reports before shipment." },
  { icon: Truck, title: "GCC Logistics & Express Clearing", desc: "Door-to-door consolidation, customs clearing and last-mile delivery across the GCC." },
  { icon: Droplets, title: "Custom Dyeing & Weaving", desc: "Pantone-matched dye lots and custom weave constructions on repeat order." },
  { icon: Handshake, title: "Bulk Payment Terms", desc: "Flexible DP terms for verified retailers — including 90-day arrangements." },
];

export default function Solutions() {
  return (
    <section id="business" data-testid="business-solutions-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#0A0B0E]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-4">Business Solutions</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug max-w-3xl">
            More than supply — <span className="italic text-gold-gradient">a trading partner.</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`solution-card-${i + 1}`}
              className={`card-shine group bg-[#181B24] border border-[#D4AF37]/15 hover:border-[#D4AF37]/50 p-8 transition-colors duration-500 ${
                i === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <s.icon size={26} strokeWidth={1.5} className="text-[#D4AF37]" />
              <h3 className="font-display text-xl sm:text-2xl text-amber-100 mt-5">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base font-light leading-relaxed text-slate-300">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
